import { createContext, useContext, useState, useEffect } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { useAuthFetch } from '../hooks/useAuthFetch';

const RolesContext = createContext({
  roles: [], isAdmin: false, isBetaTester: false, generationPaused: false, loading: true,
});

export function RolesProvider({ children }) {
  const { authFetch } = useAuthFetch();
  const isAuthenticated = useIsAuthenticated();
  const [roles, setRoles] = useState([]);
  // Site-wide kill switch, from GET /api/me. Defaults to false so a failed fetch
  // leaves the UI as it is today rather than falsely claiming a pause.
  const [generationPaused, setGenerationPaused] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      setRoles([]);
      setGenerationPaused(false);
      setLoading(false);
      return;
    }
    setLoading(true);
    authFetch(`${process.env.REACT_APP_API_URL}/api/me`)
      .then(r => r.json())
      .then(d => { setRoles(d.roles || []); setGenerationPaused(!!d.generationPaused); setLoading(false); })
      .catch(() => setLoading(false));
  }, [isAuthenticated]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <RolesContext.Provider value={{
      roles,
      isAdmin: roles.includes('admin'),
      isBetaTester: roles.includes('beta_tester'),
      generationPaused,
      loading,
    }}>
      {children}
    </RolesContext.Provider>
  );
}

export const useRoles = () => useContext(RolesContext);
